import styles from './VerticalSystemAccordion.module.scss';

import React, { FC, useRef } from 'react';
import { useVerticalSystemContext } from '../VerticalSystemContext/VerticalSystemContext';
import {
  VerticalSystemTabPanel,
  VerticalSystemTabPanelProps,
} from '../VerticalSystemTabPanel/VerticalSystemTabPanel';
import { useLinkArrowAnimation } from '../useLinkArrowAnimation';
import { useVerticalSystemAccordionAnimation } from './useVerticalSystemAccordionAnimation';

type VerticalSystemAccordionProps = Omit<VerticalSystemTabPanelProps, 'isTabActive' | 'styles' | 'tabItem'>;

export const VerticalSystemAccordion: FC<VerticalSystemAccordionProps> = props => {
  const { tabItems, activeTabItem, activeVariant, setActiveVariant } = useVerticalSystemContext();
  const rootRef = useRef<HTMLDivElement>(null);
  useLinkArrowAnimation(rootRef, styles.tabItemLink);
  useVerticalSystemAccordionAnimation();

  return (
    <div className={styles.accordion} ref={rootRef}>
      {tabItems.map(tabItem => {
        const isTabActive = tabItem.id === activeTabItem?.id;

        return (
          <VerticalSystemTabPanel
            key={tabItem.id}
            isTabActive={isTabActive}
            styles={styles}
            tabItem={tabItem}
            onSelectVariant={variant => setActiveVariant(variant === activeVariant ? undefined : variant)}
            {...props}
          />
        );
      })}
    </div>
  );
};
